import { API_BASE_URL } from './index';
import { getToken, getCompanyId } from './auth';

export const productCatalogApi = {
  getPublicCatalog: async (companyId, catalogSlug) => {
    const c = encodeURIComponent((companyId || '').trim());
    const s = encodeURIComponent((catalogSlug || '').trim().toLowerCase());
    const response = await fetch(`${API_BASE_URL}/api/public/catalog/${c}/${s}`, {
      headers: {
        Accept: 'application/json',
        'X-Company-ID': companyId,
      },
    });
    if (response.status === 404) {
      throw new Error('Catálogo no encontrado');
    }
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.detail || err.error || 'No se pudo cargar el catálogo');
    }
    return response.json();
  },

  listPages: async () => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to load catalog pages');
    }
    return response.json();
  },

  getPage: async (id) => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to load page');
    }
    return response.json();
  },

  createPage: async (data) => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to create page');
    }
    return response.json();
  },

  updatePage: async (id, data) => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to update page');
    }
    return response.json();
  },

  deletePage: async (id) => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to delete page');
    }
    return response.json();
  },

  getProductImages: async (pageId) => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages/${encodeURIComponent(pageId)}/product-images`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || error.detail || 'Failed to load product images');
    }
    return response.json();
  },

  updateProductImages: async (pageId, imagesPayload) => {
    const token = getToken();
    const companyId = getCompanyId();
    if (!token) throw new Error('No authentication token');
    if (!companyId) throw new Error('Company ID not available');

    const response = await fetch(`${API_BASE_URL}/api/product-catalog-pages/${encodeURIComponent(pageId)}/product-images`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': companyId,
      },
      body: JSON.stringify(imagesPayload),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || error.detail || 'Failed to update product images');
    }
    return response.json();
  },
};
